import React from 'react';
import PropTypes from 'prop-types';

const Step = ({ title, subtitle, children, specialclasses }) => {
  const hasClasses = specialclasses;
  let classes;
  if (hasClasses) {
    classes = 'step ' + hasClasses;
  } else {
    classes = 'step';
  }
  return (
    <div className={classes}>
      <h2 className="step__title">{title}</h2>
      {subtitle && <h3 className="step__subtitle">{subtitle}</h3>}
      {children}
    </div>
  );
};

Step.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.node.isRequired,
  specialclasses: PropTypes.string,
};

const Sub = ({ title, children }) => {
  return (
    <div className="substep">
      <h3 className="substep__title">{title}</h3>
      {children}
    </div>
  );
};

Sub.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

Step.Sub = Sub;

export default Step;
